import React, { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import { fetchRecordByKey } from "../../services/IndexedDBUtil";
import { DATABASE_NAME, STORE_NAME } from '../../services/constants'
import { displayMessage } from '../../Utils/helper';
import { getCookie } from '../../services/DataRequestService';

export default function Report1({ Product, Location }) {

  const [responseData, setResponseData] = useState([]);
  const [plotData, setPlotData] = useState([])
  const [options, setOptions] = useState({})
  const [showChart, setShowChart] = useState(false);
  
  useEffect(() => {
    const init = async () => {
      let indexedDBResponse = await fetchRecordByKey(DATABASE_NAME, STORE_NAME, 'WFActualPredictedData');
      if(indexedDBResponse?.success){
        let _data = indexedDBResponse.record?.data
        let skuData = _data.cities.find(cityData => cityData.city === Location)?.data.find(skuData => skuData.sku === Product)?.data;
        setResponseData(skuData);
        DrawReport(skuData)
        setShowChart(true);
      }
    }
    try{
      if(!Product || !Location) {
        setShowChart(false);
      }else{
        init();
      }     
    }catch(err){
      setShowChart(false);
    }
    

  }, [Product, Location ])

  function DrawReport(skuData) {
    let dataArray = [
      {
        name: "Actual",
        data: skuData.map((item) => item.actual),
      },
      {
        name: "Predicted",
        data: skuData.map((item) => item.predicted),
      },
    ];
    let frequency_year = skuData.map((item) => item.frequency_year);
    const values = {
      chart: {
        id: `Dashboard_${getCookie("username")}`,
        type: "line",
        toolbar: {
          show: true,
        },
      },
      title: {
        text: 'Graph',
        align: 'center',
      },
      plotOptions: {

      },
      colors: [
        '#0A324A', // dark blue
        '#F79548', // Orange
        '##AC1424', // red
        '#23272B', // Dark Gray
        '#3A9AD9', // Light Blue
        '#8BC34A', // Light Green
        '#FF4081', // Pink
        '#673AB7', // Purple
        '#FFEB3B', // Yellow
        '#009688', // Teal
        // '#E91E63', // Magenta
        // '#4CAF50'  // Green
      ]
      ,
      dataLabels: {
        enabled: false,
        style: {
          fontSize: '6px',
          fontWeight: 900
        },
        formatter: function (val) {
          return val
        }
      },

      xaxis: {
        categories: frequency_year,
        // categories: [1, 2, 3, 4],  //time
        title: {
          text: 'Frequency Year',

        },
        labels: {
          style: {
            fontSize: "11px",

          },
          rotate: -45,

          formatter: function (val) {
            return val
          }
        },
      },
      yaxis: [
        {
          seriesName: 'Actual VS Predicted Value',
          // opposite: true,
          labels: {
            style: {
              fontSize: "14px",

            },
            formatter: function (val) {
              return val
            }
          },
          title: {
            text: "Actual VS Predicted Value",
            showAlways: true,
            floating: true,
            style: {
              color: "#426AB3"
            },

          },
        },
        ,
      ],
      grid: {
        show: false, // This will remove the grid lines
      },
    }
    setPlotData(dataArray)
    setOptions(values)
    
  }



  return (
    <div>
    { showChart && <Chart
        align="center"
        options={options}
        series={plotData}
        type="line"
        height={500}
        width={'80%'}
      />}
    </div>
  )
}
